import { ReservationDetailFragment, ReservedResourceFragment, ResourceOccupancyFragment } from 'src/api/api.generated'
import { Currency } from 'src/api/currency'
import { getCurrentResourceOccupancy } from './resource-occupancy'
import * as R from 'ramda'
import { ReservedResourceF, GuestOccupancyF } from '../types/reservation-detail.types'
import { getNights } from 'src/utils/date'

export function getReservedResourceF(hotelDate: Date, reservation: ReservationDetailFragment, reservedResourceId: string): ReservedResourceF | null {
  const reservedResourceIndex = reservation.reservedResources?.findIndex((rr) => rr.id === reservedResourceId)
  if (reservedResourceIndex === undefined || reservedResourceIndex < 0) {
    return null
  }
  const reservedResource = reservation.reservedResources?.[reservedResourceIndex]
  if (!reservedResource) {
    return null
  }

  const currentResourceOccupancy = getCurrentResourceOccupancy<ReservedResourceFragment, ResourceOccupancyFragment>(hotelDate, reservedResource)
  if (!currentResourceOccupancy) {
    return null
  }

  const price = getPrice(reservedResource)
  const guestOccupancies: GuestOccupancyF[] = reservedResource.guestOccupancies ?? []

  return { ...reservedResource, index: reservedResourceIndex + 1, currentResourceOccupancy, price, guestOccupancies }
}

type Production = {
  currency: Currency
  amount: number
  hotelDate: Date
  chargeCategory: {
    stayIncluded: boolean
  }
}

/**
 * @ignore THIS FUINCTION IT'S NOT USED AND LIVE IT FOR FUTURE IMPLEMENTATION!
 *
 * It was created to calculate averageProduction, filed of reserved resource with price amount of resource.
 * Now the amount is returned into price filed. I don't delete that, because it calculate grouped production by currency and date,
 * maybe can be used in future implementation to calculate other useful information
 *
 * @param reservedResource
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getAverageProduction(reservedResource: ReservedResourceFragment): { amount: number; currency: Currency }[] {
  const productions = reservedResource.productions?.filter((p) => p.chargeCategory.stayIncluded) || []

  const byCurrency = R.groupBy((production: Production) => production.currency)
  const byHotelDate = R.groupBy((production: Production): string => `${production.hotelDate.getFullYear()}-${production.hotelDate.getMonth()}-${production.hotelDate.getDate()}`)
  const groupedByCurrency = byCurrency(productions)

  const result: { amount: number; currency: Currency }[] = []
  for (const key in groupedByCurrency) {
    const c = key as Currency
    const cp = groupedByCurrency[c]
    const groupedByDate = byHotelDate(cp)
    const dateSums: number[] = []
    for (const dateKey in groupedByDate) {
      dateSums.push(R.sum(groupedByDate[dateKey].map((p) => p.amount)))
    }
    const average = Math.round(R.sum(dateSums) / dateSums.length)
    result.push({ amount: average, currency: c })
  }

  return result
}

function getPrice(reservedResource: ReservedResourceFragment): number {
  let result = 0
  const isTimeResource = reservedResource?.resourceOccupancies?.[0]?.assignedResourceType?.timeConfiguration
  const nights = getNights(reservedResource.start, reservedResource.end) + (isTimeResource ? 1 : 0)
  if (reservedResource.manualPrice) {
    result = reservedResource.manualPrice * nights
  } else if (reservedResource.manualDailyPrices) {
    result = reservedResource.manualDailyPrices.reduce((prev, { price }) => prev + price, 0)
  } else if (reservedResource.dailyPricesStored?.dailyPrices) {
    result = reservedResource.dailyPricesStored?.dailyPrices.reduce((prev, { price }) => prev + price, 0)
  }
  return result
}
